<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <v-progress-linear
    :active="$root.RootProgressBar"
    class="mb-1"
    color="primary"
    fixed
    indeterminate
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'ProgressLinear'
}
</script>
